import { ArrowSmRightIcon } from '@heroicons/react/outline';
import { dropDownCardLG } from 'assets';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

interface Props {
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}
const ReferEarn: React.FC<Props> = ({ setShowDropDown, onClose }) => {
  const router = useRouter();

  return (
    <div className='px-5'>
      <div
        onClick={() => {
          onClose();
          router.push('/refer-earn');
          setShowDropDown(false);
        }}
        className='relative flex gap-x-2 w-full h-[96px] border rounded-lg border-white/5 overflow-hidden'
      >
        <Image
          src={dropDownCardLG}
          alt='Facebook'
          className='absolute top-0 right-0 h-[94px] min-w-[348px] w-[348px] max-w-[348px]'
        />{' '}
        <div className='absolute top-0 left-0 w-full h-full'>
          <div className='flex flex-col h-full justify-between py-2.5 px-4'>
            <div className='flex flex-col z-40'>
              <span className='text-base/6 font-semibold  text-white'>
                Get A Free Book
              </span>
              <span className='text-[10px] leading-[18px] font-normal text-white/80 '>
                When your friend joins, both get{' '}
                <span className='font-semibold text-white'>100 Z Coin</span>
              </span>
            </div>

            <div className='text-[10px] leading-[18px] font-normal text-white/80 flex items-center gap-1'>
              <p>1 Z coin = 1 Rupees</p>
              <div className='w-4 h-4 rounded-full flex items-center justify-center bg-white/10'>
                <ArrowSmRightIcon className='w-[11px] h-[11px]' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferEarn;
